import { createFileRoute } from '@tanstack/react-router';

import { AuthLayout } from '@auth/feature';

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
});
